export const GoogleMapApiConfig = 'AIzaSyDp8Nyr0Hf17ZI5f2LJPT0hxRX55g_q5VQ';